import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickHaulersState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-haulers.selector';

export class OneClickPreviewHaulersLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickHaulersState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
